import { createFileRoute } from '@tanstack/react-router'
import { InvitationScreen } from '@/components/team/invitation-screen'

/**
 * `/invitations/:id` — where the invitation email points.
 *
 * The only route in the app that must render for BOTH a signed-out and a
 * signed-in visitor. The auth gate in `__root.tsx` treats the two groups it
 * knows about as opposites: a protected route bounces the signed-out to
 * `/login`, and an auth screen bounces the signed-in to `/`. An invitation is
 * neither — a person arriving from their email might have an account or might
 * not, and both need to see the same page. `isPublicPath` therefore covers this
 * path while `isAuthPath` does not (see `lib/auth/session.ts`).
 */
export const Route = createFileRoute('/invitations/$id')({
  head: () => ({ meta: [{ title: 'Invitation — Constellation QR' }] }),
  component: InvitationScreen,
})
